export const setCart = (shopId, addedItems) => {
   return {
      type: "SET_CART",
      payload: {
         shopId,
         addedItems
      }
   };
};

export const addCartItem = (shopId, addedItem) => {
   return {
      type: "ADD_CART_ITEM",
      payload: {
         shopId,
         addedItem
      }
   };
};

export const changeProductQuantity = (shopId, itemId, quantity) => {
   return {
      type: "CHANGE_PRODUCT_QUANTITY",
      payload: {
         shopId,
         itemId,
         quantity
      }
   };
};

export const removeCartItem = (shopId, itemId) => {
   return {
      type: "REMOVE_CART_ITEM",
      payload: {
         shopId,
         itemId
      }
   };
};

export const clearCart = (shopId) => {
   return {
      type: "CLEAR_CART",
      payload: shopId
   };
};

export const setHasBeenFetched = (shopId) => {
   return {
      type: "SET_HAS_BEEN_FETCHED",
      payload: shopId
   };
};
